import type { EvisearchApiTyped } from './types';

import './setup';
import { evisearchApiRoot } from './root';

export const evisearch = evisearchApiRoot as EvisearchApiTyped;
